import OrderBookTable from "../../Tables/Order/OrderBookTable";
import useRequest from "../../Hooks/useRequest";
import {
  getStepOrderBook,
  ORDER_BOOK_POLL_INTERVAL_MS,
} from "../../Requests/stepRequests";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import StepOrderBookInfo from "./StepOrderBookInfo";
import { useEffect } from "react";
import { setStepAddOrderFormValues } from "../../Features/Step/stepSlice";
import useLiveOrderBooks from "../../Hooks/useLiveOrderBooks";

const StepOrderBook = () => {
  const dispatch = useAppDispatch();
  const formValues = useAppSelector(
    (store) => store.step.addOrderFormValues
  );
  const instrumentId = formValues?.instrumentId;
  const instrumentType = formValues?.instrumentType;

  const orderBookRequest = useRequest(
    () => getStepOrderBook(instrumentId || undefined, instrumentType),
    (e) => {}
  );
  const liveOrderBooks = useLiveOrderBooks({
    enabled: true,
    instrumentIds: [instrumentId],
  });

  useEffect(() => {
    if (!instrumentId) return;
    orderBookRequest.fetchData();
    const interval = setInterval(() => {
      orderBookRequest.fetchData();
    }, ORDER_BOOK_POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [instrumentId]);

  return (
    <div className="flex flex-row justify-start items-end gap-3">
      <OrderBookTable
        tableInfo={liveOrderBooks.resolveOrderBook(orderBookRequest?.response?.fullOrderBook, instrumentId || undefined)}
      />
      <StepOrderBookInfo
        fundInfo={orderBookRequest?.response?.fundInfo}
        instrumentStatistic={orderBookRequest?.response?.instrumentStatistic}
        onPriceClick={(price) => {
          if (!price || !formValues) return;
          dispatch(
            setStepAddOrderFormValues({
              ...formValues,
              fromPrice: price,
              toPrice: price,
            })
          );
        }}
      />
    </div>
  );
};

export default StepOrderBook;
